import { Pipe, PipeTransform } from '@angular/core';
import { BaseWooCommerceProduct } from '../../core/interfaces/woo-commerce/api/products/base-product-api.interface';
import { WooCommerceCartItem } from '../../core/interfaces/woo-commerce/api/cart/cart.interface';

@Pipe({
  name: 'productImage',
  standalone: true
})
export class ProductImagePipe implements PipeTransform {
  transform(product: BaseWooCommerceProduct | WooCommerceCartItem | undefined | null): string | undefined {
    if (!product) {
      return undefined;
    }

    if (product.images && product.images.length > 0 && product.images[0].src) {
      return product.images[0].src;
    }

    if (product.clover_pos_images && product.clover_pos_images.length > 0) {
      return product.clover_pos_images[0];
    }

    return undefined;
  }
}

